import React, { useState, useEffect } from 'react';
import { Avatar, Spin, Image } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { MemberProfile } from '../../model/members/MemberProfile';

interface MemberPhotoProps {
  memberProfile: MemberProfile;
  size?: number | 'large' | 'small' | 'default';
  className?: string;
  showLarge?: boolean;
}

const MemberPhoto: React.FC<MemberPhotoProps> = ({ 
  memberProfile,
  size = 'large', 
  className,
  showLarge = false
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!memberProfile) {
      setLoading(false);
      setError(true);
      return;
    }
    setLoading(false);
    setError(false);
  }, [memberProfile]);

  if (loading) {
    return <Spin size="small" />;
  }

  // Check for empty or invalid photo URL
  const hasValidPhoto = memberProfile?.photoUrl && memberProfile.photoUrl.trim() !== '';

  if (error || !hasValidPhoto) {
    return <Avatar size={size} icon={<UserOutlined />} className={className} />;
  }

  if (showLarge) {
    return (
      <Image
        src={memberProfile.photoUrl}
        alt={`${memberProfile.name}'s photo`}
        className={className}
        style={{ 
          width: '100%',
          maxWidth: '300px',
          height: 'auto',
          objectFit: 'cover',
          borderRadius: '8px'
        }}
        onError={() => {
          setError(true);
          return true;
        }}
      />
    );
  }

  return (
    <Avatar 
      size={size} 
      src={memberProfile.photoUrl} 
      className={className}
      onError={() => {
        setError(true);
        return true;
      }} 
    />
  );
};

export default MemberPhoto;